// 批发商模块 - 处理批发商信息、店铺配置等

const state = {
  wholesalerInfo: null,
  shopConfig: null,
  loading: false
};

const getters = {
  wholesalerInfo: state => state.wholesalerInfo,
  shopConfig: state => state.shopConfig,
  customerName: state => state.shopConfig?.customerName || '',
  contactPhone: state => state.shopConfig?.contactPhone || '',
  isLoading: state => state.loading
};

const mutations = {
  SET_WHOLESALER_INFO(state, info) {
    state.wholesalerInfo = info;
  },
  SET_SHOP_CONFIG(state, config) {
    state.shopConfig = config;
  },
  UPDATE_SHOP_CONFIG(state, config) {
    state.shopConfig = {
      ...state.shopConfig,
      ...config
    };
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  }
};

const actions = {
  // 获取批发商信息
  async fetchWholesalerInfo({ commit }) {
    commit('SET_LOADING', true);
    try {
      // TODO: 调用 API 获取批发商信息
      // const response = await api.get('/wholesaler/info');
      // commit('SET_WHOLESALER_INFO', response.data);
      
      // 模拟数据
      commit('SET_WHOLESALER_INFO', {
        id: 1,
        name: '顿海涛',
        type: '商家账号',
        avatar: '',
        createTime: '2024-01-01'
      });
    } catch (error) {
      console.error('获取批发商信息失败:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 获取店铺配置
  async fetchShopConfig({ commit }) {
    commit('SET_LOADING', true);
    try {
      // TODO: 调用 API 获取店铺配置
      // const response = await api.get('/wholesaler/shop-config');
      // commit('SET_SHOP_CONFIG', response.data);
      
      // 模拟数据
      commit('SET_SHOP_CONFIG', {
        customerName: '批发通商城',
        description: '专业批发平台',
        contactPhone: '400-123-4567',
        contactEmail: 'service@pifa.com',
        address: '北京市朝阳区某某街道 123 号',
        logo: '',
        businessLicense: ''
      });
    } catch (error) {
      console.error('获取店铺配置失败:', error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  // 更新店铺配置
  async updateShopConfig({ commit, dispatch }, config) {
    try {
      // TODO: 调用 API 更新店铺配置
      // await api.put('/wholesaler/shop-config', config);
      commit('UPDATE_SHOP_CONFIG', config);
      dispatch('fetchShopConfig');
      return { success: true };
    } catch (error) {
      console.error('更新店铺配置失败:', error);
      return { success: false, error: error.message };
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
